import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import img_logo_color from '../../../assets/images/Logo-color.svg';
import img_logo_en_color from '../../../assets/images/logo-color-en.svg';
import img_logo_contrast from '../../../assets/images/Logo.svg';
import img_logo_en_contrast from '../../../assets/images/Logo_EN.svg';
import "./SmallMenu.css";
import DropdownMenu from '../DropdownMenu';
import $ from 'jquery';
import UE_EN_TOP_black from "../../../assets/images/UE-EN-Top-black.svg";
import UE_PL_TOP_black from "../../../assets/images/UE-PL-Top-black.svg";
import UE_EN_TOP_white from "../../../assets/images/UE-EN-Top-white.svg";
import UE_PL_TOP_white from "../../../assets/images/UE-PL-Top-white.svg";
export default class SmallMenu extends Component {

    constructor(props) {
        super(props);
        let data = { main_menu: [], extend_nav: [], ...props.data };
        data.main_menu = Array.isArray(data.main_menu) ? data.main_menu : JSON.parse(data.main_menu);
        data.extend_nav = Array.isArray(data.extend_nav) ? data.extend_nav : JSON.parse(data.extend_nav);
        this.state = {
            data: data,
            data2: props.data2,
            config: { config: [], ...props.config },
            activeSub: ""
        }
    }



    toggleContrast = () => {
        $("body").toggleClass("contrast-up");
        if ($("body").hasClass("contrast-up")) {
            localStorage.setItem('contrast', 'up');
            $("body.contrast-up img.gb-img-logocust-footer").attr("src", `${window.location.href.indexOf("/en/") > -1 ? img_logo_en_contrast : img_logo_contrast}`)
            $("body.contrast-up div.UE_logo a img").attr("src", `${window.location.href.indexOf("/en/") > -1 ? UE_EN_TOP_white : UE_PL_TOP_white}`)
            $("#contrast-button").addClass("contrast-active");
        }
        else {
            localStorage.setItem('contrast', 'down');
            $("body img.gb-img-logocust-footer").attr("src", `${window.location.href.indexOf("/en/") > -1 ? img_logo_en_color : img_logo_color}`)
            $("body div.UE_logo a img").attr("src", `${window.location.href.indexOf("/en/") > -1 ? UE_EN_TOP_black : UE_PL_TOP_black}`)
            $("#contrast-button").removeClass("contrast-active");
        }
    }

    render() {
        const logo = window.location.href.indexOf("/en/") > -1 ? img_logo_en_contrast : img_logo_contrast;
        const nifcUrl = window.location.href.indexOf("/en/") > -1 ? "https://nifc.pl/en/" : "https://nifc.pl/pl/";
        const digitalUrl = window.location.href.indexOf("/en/") > -1 ? "https://nauka.nifc.pl/en/programy-unijne/lista" : "https://nauka.nifc.pl/pl/programy-unijne/lista";
        const logoClass = this.state.data.chopin_menu ? "img-logocust-wrapper chopin-menu" : "img-logocust-wrapper";
        const logoImg = this.state.data.chopin_menu ? <a href={this.state.data.chopin_menu} aria-label="dmp-logo"><div className="dmp-logo"></div></a> : null;

        // Variable for underline in submenu
        const active = this.state.data2.selected_sub_menu_id ? this.state.data2.selected_sub_menu_id : "";

        var title = this.state.data.header ? this.state.data.header : [];


        const addInfo = this.props.data.header ?
            (
                <div className="row">
                    <div className="col-xl-12 col-sm-12 hidden-md hidden-lg hidden-xl header-add-info">
                        <div>{this.props.data.header.line_1}</div>
                        <div>{this.props.data.header.line_2}</div>
                        <div>{this.props.data.header.line_3}</div>
                    </div>
                </div>

            ) : null

        if (localStorage.getItem('contrast') == "up") {
            $("body").addClass("contrast-up");
        }
        if (localStorage.getItem('contrast') == "down") {
            $("body").removeClass("contrast-up");
        }

        const contrastClass = localStorage.getItem('contrast') == 'up' ? "contrast-active" : "";

        const logoChose = () => {
            const contrast = localStorage.getItem('contrast')
            const isAng = window.location.href.indexOf("/en/") > -1
            if (contrast === "down") {
                return isAng ? UE_EN_TOP_black : UE_PL_TOP_black
            } else if (contrast === "up") {
                return isAng ? UE_EN_TOP_white : UE_PL_TOP_white
            } else {
                return isAng ? UE_EN_TOP_black : UE_PL_TOP_black
            }
        }

        return (
            <div className={`container SmallMenu ${this.state.data.sub_menu ? "submenu" : ""}`}>
                <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                        <a href={nifcUrl}>
                            <div className={logoClass}>
                                <img src={logo} alt="nifc" className="img-responsive img-logocust" style={this.state.data.chopin_menu ? {} : { marginBottom: "20px" }} />
                            </div>
                        </a>
                        {logoImg}
                        <div className="UE_logo">
                            <a href={digitalUrl} aria-label="european-union logo">
                                <img src={logoChose()} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="hidden-xs hidden-sm col-md-8 col-lg-8 extraset-item">
                        <ul className="mainmenu-list mainmenu-list-colaps">
                            {this.state.data.main_menu.map(function (object, i) {
                                let underline = object.hover ? "border" : "";
                                return (
                                    <li className="gb-offset-elem" key={object.id}>
                                        <a href={object.url} className={`gb-offset-unit ${underline}`} style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.01)" }}>{object.name}</a>
                                    </li>
                                );
                            })}
                        </ul>
                        {this.state.data.sub_menu ? (
                            <ul className="submenu">
                                {this.state.data.sub_menu.map(function (item, index) {
                                    const elementActive = index + 1 == active ? "active" : "";
                                    return (
                                        <li className={`${elementActive}`} key={index}>
                                            <a href={item.url} style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.01)" }}>
                                                {item.title ? item.title : item.title_pl}
                                            </a>
                                        </li>
                                    )
                                })}
                            </ul>
                        ) : null}
                        {this.props.data.header ? (
                            <div className="sm-wrapper">
                                <p className="sm-wrapper__text-top">{title.line_1}</p>
                                {title.line_2 && (
                                    <h1 className="sm-wrapper__text-middle">{title.line_2}</h1>
                                )}
                                <p className="sm-wrapper__text-bottom custom-header-text-1">{title.line_3}</p>
                                <p className="sm-wrapper__text-bottom custom-header-text-2">{title.line_4}</p>
                                <p className="sm-wrapper__text-bottom custom-header-text-3">{title.line_5}</p>
                            </div>
                        ) : null
                        }

                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 padding-0">
                        <div className="header-extentnav-wrapper">
                            <nav className="navbar navbar-default">
                                <div className="container-fluid custom-gb-fluid">
                                    <DropdownMenu data={this.state.data} config={this.state.config}>
                                        <div className="navbar-header">
                                            <button type="button" className="navbar-toggle collapsed" aria-label="Toggle menu">
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                            </button>
                                        </div>
                                    </DropdownMenu>

                                    <div className=" navbar-collapse gb-navbar-collapse" id="bs-example-navbar-collapse-1">
                                        <div className="nav navbar-nav header-extentnav-holder row">
                                            {this.state.data.extend_nav.map(function (object, i) {
                                                return (
                                                    <div className="header-extendetnav-item col-md-4" key={i}>
                                                        {object.url ? (
                                                            object.hasOwnProperty('external') && object.external === true ? (
                                                                <a href={object.url} target="_blank" className="navel-unit">
                                                                    <div className="navel-unit-img"
                                                                        style={{ backgroundImage: "url(" + object.img + ")", backgroundPosition: "center", backgroundSize: "cover", height: 30, textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.01)" }}
                                                                        dangerouslySetInnerHTML={{ __html: `${object.description}` }}>
                                                                    </div>
                                                                </a>
                                                            ) : (
                                                                <Link to={object.url} className="navel-unit" aria-label={"language button"}>
                                                                    <div className="navel-unit-img"
                                                                        style={{ backgroundImage: "url(" + object.img + ")", backgroundPosition: "center", backgroundSize: "cover", height: 30 , textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.01)"}}
                                                                        dangerouslySetInnerHTML={{ __html: object.description ? object.description : "" }}>
                                                                    </div>
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <div className="navel-unit disabled">
                                                                <div className="navel-unit-img"
                                                                    style={{ backgroundImage: "url(" + object.img + ")", backgroundPosition: "center", backgroundSize: "cover", height: 30 }}
                                                                    dangerouslySetInnerHTML={{ __html: `${object.description}` }}>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                            <div className="header-extendetnav-item col-md-4 asd123">
                                                <button id="contrast-button" className={contrastClass} onClick={this.toggleContrast}>A</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>

                </div>
                {addInfo}
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/SmallMenu/SmallMenu.js